import { get, put, post } from "../../services/HttpService";

export class Settings {
  constructor(taxPaymentSettings = {}) {
    this.set(taxPaymentSettings);
  }

  static validations = {
    approval_config: [],
    enable_tax_approver_flow: false,
  };

  /**
   * @memberof Settings
   * @type API
   * @returns Promise
   */
  static list = (queryData = {}, config = {}) => {
    return get(`tax-payments/v1/internal/tax_payment_settings/`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };

  static create = (queryData = {}, config = {}) => {
    return post(`tax-payments/v1/internal/tax_payment_settings/`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };

  static update = (queryData = {}, config = {}) => {
    return put(`tax-payments/v1/internal/tax_payment_settings/`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };

  /**
   * @memberof Settings
   * @type Getter Method
   * @returns Settings
   */
  get = () => {
    return {
      id: this.uuid,
      approval_config: this.approval_config,
      enable_tax_approver_flow: this.enable_tax_approver_flow,
    };
  };
}
